import { redirect } from "@/router";

export const Loader = () => redirect("/billing/dues-management/reporting/unpaid-dues");
